module.exports = __webpack_public_path__ + "static/media/sedeestrellaroja.8ee6367e.jpg";